import axios from 'axios';

import { setAlert } from './alert';

import { RECIBO } from './types';

// Obtener recibo
export const obtenerVenta = (folio) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = {
        folio
    }

    try {
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/recibos/detalles`, body, config);

        dispatch({
            type: RECIBO.OBTENER,
            payload: res.data.venta
        });

        dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        if(error?.response?.data?.msg) {
            dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const limpiarVenta = () => dispatch => {
    dispatch({
        type: RECIBO.OBTENER,
        payload: null
    });
}